<template>
  <div id="container">
    <div class="box_one" style="margin-bottom:5px"> 
      <cont-top/>
    </div>    
    <div class="main" style="margin-bottom:5px">
      <div class="title">
        <div class="title_name"></div>
      </div>
      
      <div class="main-cont">
        <router-link to="images1" tag="div" append>
          <div class="item_cont">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img4.png')"
              fit="contain">
            </el-image>
            <div style="height:17px;width:153px;margin:0 auto">
              <el-image
                style="height:17px;width:153px;"
                :src="require('@/assets/image/moment/wonderfulImage/img5.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

        <router-link to="images2" tag="div" append>
          <div class="item_cont" style="margin-left:35px">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img7.png')"
              fit="contain">
            </el-image>
            <div style="height:17px;width:133px;margin:0 auto">
              <el-image
                style="height:17px;width:133px;"
                :src="require('@/assets/image/moment/wonderfulImage/img8.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

        <router-link to="images3" tag="div" append>
          <div class="item_cont" style="margin-left:35px">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img9.png')"
              fit="contain">
            </el-image>
            <div style="height:16px;width:116px;margin:0 auto">
              <el-image
                style="height:16px;width:116px;"
                :src="require('@/assets/image/moment/wonderfulImage/img10.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

        <router-link to="images4" tag="div" append>
          <div class="item_cont">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img11.png')"
              fit="contain">
            </el-image>
            <div style="height:17px;width:191px;margin:0 auto">
              <el-image
                style="height:17px;width:191px;"
                :src="require('@/assets/image/moment/wonderfulImage/img12.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

        <router-link to="images5" tag="div" append>
          <div class="item_cont" style="margin-left:35px">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img13.png')"
              fit="contain">
            </el-image>
            <div style="height:17px;width:236px;margin:0 auto">
              <el-image
                style="height:17px;width:236px;"
                :src="require('@/assets/image/moment/wonderfulImage/img14.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

        <router-link to="images6" tag="div" append>
          <div class="item_cont" style="margin-left:35px">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img15.png')"
              fit="contain">
            </el-image>
            <div style="height:17px;width:102px;margin:0 auto">
              <el-image
                style="height:17px;width:102px;"
                :src="require('@/assets/image/moment/wonderfulImage/img16.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

        <router-link to="images7" tag="div" append>
          <div class="item_cont">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img17.png')"
              fit="contain">
            </el-image>
            <div style="height:17px;width:227px;margin:0 auto">
              <el-image
                style="height:17px;width:227px;"
                :src="require('@/assets/image/moment/wonderfulImage/img18.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

        <router-link to="images8" tag="div" append>
          <div class="item_cont" style="margin-left:35px">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img19.png')"
              fit="contain">
            </el-image>
            <div style="height:17px;width:95px;margin:0 auto">
              <el-image
                style="height:17px;width:95px;"
                :src="require('@/assets/image/moment/wonderfulImage/img20.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

        <router-link to="images9" tag="div" append>
          <div class="item_cont" style="margin-left:35px">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img21.png')"
              fit="contain">
            </el-image>
            <div style="height:17px;width:176px;margin:0 auto">
              <el-image
                style="height:17px;width:176px;"
                :src="require('@/assets/image/moment/wonderfulImage/img22.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

        <router-link to="images10" tag="div" append>
          <div class="item_cont">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img23.png')"
              fit="contain">
            </el-image>
            <div style="height:17px;width:163px;margin:0 auto">
              <el-image
                style="height:17px;width:163px;"
                :src="require('@/assets/image/moment/wonderfulImage/img24.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

        <router-link to="images11" tag="div" append>
          <div class="item_cont" style="margin-left:35px">
            <el-image
              style="height:16px;width:267px;margin-bottom:4px"
              :src="require('@/assets/image/moment/wonderfulImage/img3.png')"
              fit="contain">
            </el-image>
            <el-image
              style="height:178px;width:267px;margin-bottom:15px"
              :src="require('@/assets/image/moment/wonderfulImage/img25.png')"
              fit="contain">
            </el-image>
            <div style="height:17px;width:148px;margin:0 auto">
              <el-image
                style="height:17px;width:148px;"
                :src="require('@/assets/image/moment/wonderfulImage/img26.png')"
                fit="contain">
              </el-image>
            </div>
          </div>
        </router-link>

      </div>



    </div>
    <div class="box_bottom" > 
      <cont-bottom/>
    </div>

  </div>
</template>

<script>
import ContTop from './Cont_top'
import ContBottom from '@/views/Components/Cont_bottom'


export default {
  data() {
    return {
      fit : 'contain'
    }
  },
  components : {
    ContTop ,
    ContBottom ,
  }
}

</script>

<style lang="stylus" scoped>
.clear:after {
  display: block;
  clear: both;
  content: '';
}

#container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 0 52px;

}
  .main-cont{
    display flex 
    flex-wrap wrap
    padding : 0 50px;
    box-sizing:border-box;
    justify-content flex-start
  }
    .item_cont{
      width 267px;
      height 250px;
      margin-bottom 45px
      cursor pointer 
    }

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/moment/wonderfulImage/img1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 23px 56px 24px 57px; 
  box-sizing: border-box;
}

.title_name {
  width: 57px;
  height: 61px;
  background: url('~@/assets/image/moment/wonderfulImage/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}

</style>